import script from "./verifikasiDataKontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./verifikasiDataKontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./verifikasiDataKontraktorPage.vue?vue&type=style&index=0&id=cf4f582e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf4f582e"]])

export default __exports__